import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import PropertyList from './components/PropertyList';
import PropertyDetail from './components/PropertyDetail';
import './styles/App.css';
import apiService from './services/api';

function App() {
  useEffect(() => {
    // Telegram Web App initialization
    if (window.Telegram?.WebApp) {
      const tg = window.Telegram.WebApp;
      tg.ready();
      tg.expand();
      
      // Set theme colors
      tg.setHeaderColor('#2563eb');
      tg.setBackgroundColor('#f8fafc');
    }

    // Identify/create user on app open
    (async () => {
      try {
        let externalId;
        let name, username;

        // Если мы внутри Telegram, всегда используем его данные
        if (window.Telegram?.WebApp?.initDataUnsafe?.user) {
          const u = window.Telegram.WebApp.initDataUnsafe.user;
          externalId = `tg_${u.id}`;
          name = [u.first_name, u.last_name].filter(Boolean).join(' ');
          username = u.username;
        } else {
          // Вне Telegram — берем сохраненный или генерим анонимный
          externalId = localStorage.getItem('extUserId');
          if (!externalId) {
            externalId = `anon_${Math.random().toString(36).slice(2)}`;
          }
        }
        localStorage.setItem('extUserId', externalId);
        await apiService.identifyUser({ externalId, name, username });
      } catch (e) {
        // swallow
      }
    })();
  }, []);

  return (
    <div className="min-h-screen bg-gray-50">
      <Router>
        <Routes>
          <Route path="/" element={<PropertyList />} />
          <Route path="/property/:id" element={<PropertyDetail />} />
        </Routes>
      </Router>
    </div>
  );
}

export default App;
